// extracted by mini-css-extract-plugin
export default {"Container":"faq_Container__zkomV","leftCon":"faq_leftCon__Mo42Q","rightCon":"faq_rightCon__zqyom","title":"faq_title__ZIexU","innerCon":"faq_innerCon__Fpc7Z"};